<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <repse-documentation-table
            :data="data"
            @back="back"
            @loadMore="loadMore"
            @search="search"
            @details="showDetails"
            :title="'REPSE - Documentos'"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import RepseDocumentationTable from './components/RepseDocumentationTable.vue'
import vendor from '@/http/requests/vendor/index.js'

export default {
  components: {
    RepseDocumentationTable,
  },
  data() {
    return {
      data: [],
      item: {},
      lastPage: 1,
      loadingPage: 'repse-documentation-loading',
      params: {
        rfc: '',
        search: '',
        page: 1,
      },
      vendor: {
        id: '',
        name: '',
      },
    }
  },
  methods: {
    back: function () {
      this.$router.push('/expenses')
    },
    getData: function () {
      this.$vs.loading()
      vendor
        .getRepseDocumentation(this.params)
        .then((response) => {
          this.data = response.data.documentation
          this.$vs.loading.close()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.$vs.loading.close()
        })
    },
    // getVendor: function (id) {
    //   this.$vs.loading()
    //   vendor
    //     .getVendor(id)
    //     .then((response) => {
    //       this.vendor = Object.assign({}, response.data.vendor)
    //       this.$vs.loading.close()
    //       this.getData()
    //     })
    //     .catch((response) => {
    //       this.showValidationErrors(response)
    //       this.$vs.loading.close()
    //     })
    // },
    loadMore: function () {
      return
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    showDetails: function (item) {
      console.log(item)
      this.$store.dispatch('setDocumentTitle', item.documentName)
      this.$router.push({ name: 'repse-requests', params: { id:item.id } })
    },
    init: function () {
      const storageVendor = localStorage.getItem('vendor')
      let vendorActive = JSON.parse(storageVendor)
      let repseActive = vendorActive.repse_active

      if(repseActive == 1){
        const storageVendor = localStorage.getItem('vendor')
        let vendor = JSON.parse(storageVendor)
        this.params.rfc = vendor.rfc
        this.getData()
      }else{
        this.$router.push('/pages/not-authorized')
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.$vs.loading()
      } else {
        this.$vs.loading.close()
      }
    },
  },
}
</script>

    <style>
</style>
